import { Injectable } from '@angular/core';
import { ApiHttpClient,  } from '../modules/tcm-core.module';
import { ListOption } from '../modules/tcm-core.module';
import { ListOptionRequest } from '../modules/tcm-core.module';

@Injectable({
  providedIn: 'root'
})
export class CampaignDataService {
  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public async downloadFileAsync(id: number | string, timeout: Promise<any>): Promise<any> {
    try {
      var response = await this.downloadFileBlobAsync(id, timeout);
      
      response.save();
    }
    catch (e) {

    }
  }

  public getCampaignOptionsAsync(query: string, cancellationToken: Promise<any>): Promise<ListOption<number>[]> {
    const request: ListOptionRequest = { searchString: query };
    return this.httpClient.getJsonAsync<ListOption<number>[]>('campaigns/options', request, cancellationToken);
  }

  public getAllCampaignOptionsAsync(cancellationToken: Promise<any>): Promise<ListOption<number>[]> {
    return this.httpClient.getJsonAsync<ListOption<number>[]>('campaigns/getAllListOptions', {}, cancellationToken);
  }

  public getCampaignOptionsForClinicAsync(clinicId: number, cancellationToken: Promise<any>): Promise<ListOption<number>[]> {
    const request: any = { clinicId: clinicId };
    return this.httpClient.getJsonAsync<ListOption<number>[]>('campaigns/OptionsForClinic', request, cancellationToken);
  }

  public getCampaignOptionsForReferralSourceAsync(referralSourceId: number, clinicId: number, Id: number, FromApp: number, cancellationToken: Promise<any>): Promise<ListOption<number>[]> {
    const request: any = { referralSourceId: referralSourceId, clinicId: clinicId, Id: Id, FromApp: FromApp };
    return this.httpClient.getJsonAsync<ListOption<number>[]>('campaigns/OptionsForReferralSource', request, cancellationToken);
  }

  public getReferralSourceOptionsForCampaignAsync(campaignId: number, clinicId: number, cancellationToken: Promise<any>): Promise<number> {
    const request: any = { campaignId: campaignId, clinicId: clinicId };
    return this.httpClient.getJsonAsync<any>('campaigns/getReferralSourceIdForCampaign', request, cancellationToken);
  }

  public checkCampaignDocumentTemplateExistsAsync(campaignId: number, documentTemplateId: number, id: number, timeout: Promise<any>): Promise<boolean> {
    const data = { campaignId: campaignId, documentTemplateId: documentTemplateId, id: id };
    return this.httpClient.getJsonAsync<boolean>('CampaignDocumentTemplates/CheckCampaignDocumentTemplateExists', data, timeout, false);
  }

  public generateLettersAsync(campaignId: number, documentTemplateId: number, id: number, timeout: Promise<any>): Promise<boolean> {
    const data = { campaignId: campaignId, documentTemplateId: documentTemplateId, id: id };
    return this.httpClient.getJsonAsync<boolean>('CampaignDocumentTemplates/GenerateLetters', data, timeout, false);
  }

  public generateLettersByTemplatesAsync(campaignDocumentTemplateIds: number[], timeout: Promise<any>): Promise<boolean> {
    return this.httpClient.postJsonAsync('CampaignDocumentTemplates/GenerateLettersByTemplates', campaignDocumentTemplateIds, timeout, false);
  }

  private downloadFileBlobAsync(id: number | string, timeout: Promise<any>) {
    return this.httpClient.getFileAsync(`CampaignDocumentTemplates/Download?id=${id.toString()}`, timeout);
  }

  public deleteCampaignDocumentTemplateAsync(id: number, timeout: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync('CampaignDocumentTemplates/Delete', id, timeout);
  }
}
